import React, { useEffect } from '../../../_snowpack/pkg/react.js';
import Loading from '../../modules/loading/index.js';
export default function MagicLinkLandingPage() {
  const token = new URL(window.location.href).searchParams.get('token');
  useEffect(() => {
    const timeout = setTimeout(function () {
      location.href = `/auth/magic-link/redirect?token=${token}`;
    }, 3000);
    return () => clearTimeout(timeout);
  }, [token]);
  return /*#__PURE__*/React.createElement(Loading, null, "Hold on. Letting you in...");
}